import * as React from 'react';
import { Props } from 'react';

import './Spiner.scss';

interface SpinerProps extends Props<Spiner> {
    icon?: string;
    color?: string;
    style?: any;
    size?: string;
}

export class Spiner extends React.Component<SpinerProps> {
    render() {
        const {icon, color, style, size} = this.props;
        return (
            <div className='spiner-container' style={style}>
                <i className={`fa fa-${icon ? icon : 'spinner'} fa-spin`} style={{color: color, fontSize: size}} />
            </div>
        );
    }
}

export default Spiner;



// WEBPACK FOOTER //
// ./src/components/Shared/Spiner/Spiner.tsx